<template>
<div style="margin-top: 20px;">
  <loading :active.sync="isLoading"
    color="#5bad2b"
    :is-full-page="Boolean(fullPage)"></loading>
      <div class="col-md-12" style="margin-top: 20px;margin-bottom: 25px;">
          <!-- Custom Tabs -->
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li v-on:click="navigation('Post')"><a href="#tab_1" data-toggle="tab">Post</a></li>
              <li class="active" v-on:click="navigation('To-be-Scheduled')"><a href="#tab_2" data-toggle="tab">To-be Scheduled</a></li>
              <li v-on:click="navigation('Scheduled')"><a href="#tab_3" data-toggle="tab">Scheduled</a></li>
              <li v-on:click="navigation('Result')"><a href="#tab_4" data-toggle="tab">Result</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="tab_1">
              <div class="col-md-6 remove-pad">
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h3 class="box-title">To-be Scheduled</h3>
                  </div>
                  <div class="box-header with-border">
                    <input type="text" v-model="postsearch" @keyup="getDatas()" class="form-control pull-left search-text" placeholder="Search" style="width:50%;height: 20% !important;">
                    <div style="width:50%;" class="pull-right">
                      <div class="form-group">
                        <div class="form-select pull-right" style="width: 50%;">
                          <select class="form-control input-sm" v-model="postsort" @change="getDatas()">
                            <option value="7">Last 7 days</option>
                            <option value="30">Last 30 days</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                      </div>
                      <span class="pull-right ml-1" style="margin-top: -5px;">Sort by</span>
                    </div>
                  </div>
                  <!-- /.box-header -->
                  <div class="box-body scroll-manual">
                    <div style="text-align:center; margin-top:30%" v-if="datas.length < 1">
                      <img src="../../assets/img/tobe_empty.svg" alt="Product Image" style="width: 150px;">
                      <br>
                      <span style="font-size: 12px;color: black;">No data found</span>
                    </div>
                    <ul class="products-list product-list-in-box">
                       <li class="item" v-for="(x, index) in datas" :key="index" @click="getReleventProfile(x._id, x)" v-bind:class="{'active': selectpost === x._id}">
                          <div class="row">
                          <div class="col-md-8 p-1">
                            <div class="product-img">
                              <img v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="img-circle">
                              <img v-if="x.profile_picture =='' || x.profile_picture ==null" src="../../assets/img/org-default.png" class="img-circle">
                              <img v-if="x.post_expired =='true'" src="../../assets/img/expired.png" class="img-circle exp-img mt-2" style="width: 13px !important;margin-left:-9px;height: 13px !important;">
                            </div>
                            <div class="product-info">
                              <a href="javascript:void(0)" class="product-title">{{x.job_tittle}} <img v-if="x.notification_count > 0" src="../../assets/img/green_dot.svg" class="img-circle">
                              </a>
                              <span class="product-description" :title="x.post_unique_id"><span class="skill-lable">{{x.post_unique_id}}</span></span>
                            </div>
                          </div>
                          <div class="col-md-4 p-1">
                              <div class="pull-right showdate">
                                <span class="ml-1">Posted on : {{x.created_at | formatDate}}</span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                          <div class="col-md-7 p-1">
                            <div class="ml-5 mt-2">
                            <span class="product-description" :title="x.primaryskillnames"><span class="skill-lable">Skills : </span>
                              {{x.primaryskillnames}}
                            </span>
                          </div>
                          </div>
                          <div class="col-md-5 showdate1">
                            <span class="pull-right" v-if="x.isclient =='yes'">Created by : {{x.created_by_name}}</span>
                          </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12 p-1 tc mt-2">
                              <div class="btn-group">
                                <button type="button" class="btn bg-full btn-sm"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i> To-be Scheduled</button>
                                <button type="button" class="btn btn-default btn-sm b-c ml-1">{{x.tobeschedule_count}}</button>
                              </div>
                              <div class="btn-group">
                                <button type="button" class="btn bg-full btn-sm"><i class="fa fa-calendar" aria-hidden="true"></i> Scheduled</button>
                                <button type="button" class="btn btn-default btn-sm b-c ml-1">{{x.schedule_count}}</button>
                              </div>
                              <div class="btn-group">
                                <button type="button" class="btn bg-full btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Completed</button>
                                <button type="button" class="btn btn-default btn-sm b-c ml-1">{{x.complete_count}}</button>
                              </div>
                            </div>
                          </div>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-6 remove-pad">
                <div class="box box-primary">
                  <div class="box-header with-border" v-if="datas.length > 0 && selectdata">
                    <div class="direct-chat-msg">
                      <div class="clearfix">
                        <span class="direct-chat-name pull-left" v-if="selectdata.job_tittle">{{selectdata.job_tittle}}</span>
                        <!-- <span class="direct-chat-timestamp pull-right">{{selectdata.post_unique_id}} <div v-if="selectdata.post_expired =='true'"><img src="../../assets/img/expired.png" class="img-circle exp-img" style="width: 13px !important;margin-top:2px;height: 13px !important;"> <span class="expired">Expired</span></div></span> -->
                      </div>
                    </div>
                    <div class="direct-chat-msg">
                      <span class="direct-chat-timestamp pull-left">{{selectdata.post_unique_id}} <span class="ml-20" v-if="selectdata.post_expired =='true'"><img src="../../assets/img/expired.png" class="img-circle exp-img" style="width: 13px !important;margin-top:2px;height: 13px !important;"> <span class="expired">Expired</span></span></span>
                    </div>
                    <div class="direct-chat-msg">
                      <span class="direct-chat-timestamp pull-left" v-if="selectdata.primaryskillnames">Skills <span style="color:black"> {{selectdata.primaryskillnames}}</span></span>
                      <span class="direct-chat-timestamp pull-right" v-if="selectdata.post_validity">Validity : {{selectdata.post_validity | formatDate}}</span>
                    </div>
                  </div>
                  <div class="box box-primary" style="margin-bottom: 0px;" v-if="datas.length > 0 && selectdata">
                    <div class="box-header with-border">
                      <span class="direct-chat-name">To-be Scheduled</span>
                      <div class="box-tools pull-right">
                        <span>Sort by: </span>
                        <button type="button" class="btn btn-box-tool" data-widget="collapse">Timings <i class="fa fa-long-arrow-up" aria-hidden="true"></i><i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn btn-box-tool" data-widget="remove">Price <i class="fa fa-long-arrow-up" aria-hidden="true"></i><i class="fa fa-long-arrow-down" aria-hidden="true"></i></button>
                      </div>
                    </div>
                  </div>
                  <!-- /.box-header -->
                  <div style="margin-top:50%;text-align:center" v-if="releventprofilesLength < 1">
                     <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                  </div>
                  <CardView :selectdata="selectdata" :tobeschedule="true" :data="releventprofiles" :showRole="showRole" :selectpost="selectpost"></CardView>
                  <!-- <div class="direct-chat-messages" v-for="(x, index) in releventprofiles" :key="index">
                    <div class="direct-chat-msg">
                      <img @click="showModal(x._id)" v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="direct-chat-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && (x.gender == null || x.gender == '')" src="../../assets/img/default.png" class="direct-chat-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../../assets/img/female_default.png" class="direct-chat-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'" src="../../assets/img/male_default.png" class="direct-chat-img">
                      <div class="direct-chat-info clearfix">
                        <span class="direct-chat-name pull-left ml8 name" @click="showModal(x._id)">{{x.first_name}} {{x.last_name}}<br>
                          <span style="color:#999;font-weight: 400;">Applied on : {{x.interviewer_interest_date | formatDatetimea }}</span>
                        </span>
                        <span class="direct-chat-timestamp pull-right" style="width:25%" @click="showSheduledetails(x._id,x.statusval)">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(x.interviewer_rating)" :read-only="true"></star-rating></span>
                        <button v-if="!Boolean(showRole)" class="btn btn-default btn-xs btns pull-left ml8" @click="showSheduledetails(x._id,x.statusval)"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                      </div>
                      <div class="direct-chat-info clearfix">
                        <span class="direct-chat-timestamp pull-left" @click="showSheduledetails(x._id,x.statusval)">Skillset : <span style="color:black"> {{x.userskillnames}}</span></span>
                        <div class="seekTime">
                        <div v-if="x.status !='cancelled' && selectdata.isclient =='no'">
                          <div class="myseektime">
                        <label v-if="Boolean(showRole)" for="">{{x.availability_req_status}}</label>
                           <button v-if="Boolean(showRole)" data-toggle="modal" data-target="#seekTime" @click="submitRequest(x._id)" class="btn btn-primary btn-sm pull-right seekbtn"><i class="uil uil-clock" aria-hidden="true"></i> Seek Time</button>
                          <button class="btn btn-success btn-sm pull-right" @click="showShedule(x._id)"><i class="fa fa-calendar" aria-hidden="true"></i> Schedule</button> </div>
                        <span v-if="x.status !='cancelled' && selectdata.isclient =='no' && x.schedule_count < 1" @click="showReason(x._id)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer"><i class="fa fa-times" aria-hidden="true"></i> cancel</span>
                        <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.status =='cancelled'" class="pull-right" style="color:#ff2627"> Cancelled</span></div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <!-- Modal for short intro -->
                <div class="modal fade" id="seekTime" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title closebtnmodel" id="exampleModalLabel"><strong>Seek Time Request</strong> <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button></h4>
                      </div>
                      <div class="modal-body txtarea">
                        <label for="">Remarks*</label>
                        <textarea  class="invalid-feedback" name="" id="" cols="100" rows="5" v-model="comments"></textarea>
                        <span style="color:red">{{remarkAlert}}</span>

                        <!-- <div
                                  v-if=" $v.comments.$error"
                                  class="invalid-feedback" style="color:red; font-size:12px;text-align:left;"
                                >
                                  <span v-if="!$v.comments.required"
                                    >seek time response is required</span
                                  > -->
                                  <!-- <span v-if="$v.comments.required && !$v.comments"
                                    >Short Intro must be at least 50 characters</span
                                  > -->
                                <!-- </div> -->
                      </div>
                      <!-- <p style="float:right;padding:4px">Max 200 Characters</p> -->
                      <br>
                      <div class="modal-footer introBtn">
                        <button type="button" class="btn " data-dismiss="modal">Close</button>
                        <button type="button" class="btn saveaccdetialsbtn"  v-on:click="askTime()">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <!-- /.tab-pane -->
            </div>
            <!-- /.tab-content -->
          </div>
          <!-- nav-tabs-custom -->
        </div>
        <profile-modal v-model="modalOpen" v-if="modalOpen"></profile-modal>
        <add-shedule v-model="shwovalue" :shwovalueAddSchedule="shwovalue" v-if="shwovalue"></add-shedule>
        <schedule-details v-model="sheduledetailsOpen" v-if="sheduledetailsOpen"></schedule-details>
        <reason-popup v-model="reasonopen" v-if="reasonopen"></reason-popup>
    </div>
</template>
<script>
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { BaseURL } from '../../shared/classes'
import router from '../../router/index'
import ProfileModal from '../Feature/profileDetails'
import ReasonPopup from '../Feature/reasonpopup'
import AddShedule from '../Feature/addshedule'
// import StarRating from 'vue-star-rating'
import ScheduleDetails from '../Feature/to-be-shedule-detail'
import Vue from 'vue'
import Loading from 'vue-loading-overlay'
import $ from 'jquery'
import 'vue-loading-overlay/dist/vue-loading.css'
import CardView from '../Feature/cardView'
export const EventBus = new Vue()
const clickHandler = function (userid) {
  console.log(`Oh, that's nice. It's gotten ${userid} clicks! :)`)
}
// Listen to the event.
EventBus.$on('i-got-clicked', clickHandler)

export default {
  name: 'ToBeShedule',
  data () {
    return {
      comments: '',
      viewid: [],
      job_title: '',
      job_skills: '',
      job_validity: '',
      job_postedon: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      interestedsend: [],
      datas: [],
      releventprofiles: [],
      releventprofilesLength: 0,
      interested: [],
      postdatas: [],
      bothinterest: [],
      availabledate: [],
      groupeddate: [],
      availabletime: [],
      startdatetime: '',
      enddatetime: '',
      selectdate: '',
      post_unique_id: '',
      post_expired: '',
      mainurl: '',
      base_urls: BaseURL,
      postsearch: '',
      postsort: 7,
      datassShow: 15,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      tabOne: false,
      selectpost: '',
      profileid: '',
      actiontype: '',
      modalOpen: false,
      shwovalue: false,
      showRole: false,
      reasonopen: false,
      sheduledetailsOpen: false,
      isLoading: true,
      fullPage: true,
      selectdata: JSON.parse(localStorage.getItem('postId')),
      submitted: false,
      tempId: '',
      seektimemsg: '',
      remarkAlert: ''
      // showSeek: false
    }
  },
  components: {
    AddShedule, ProfileModal, ReasonPopup, ScheduleDetails, Loading, CardView
  },
  created () {
    this.tabOne = true
    this.getDatas()
    this.$root.$emit('navigate', 'To-be-Scheduled')
    var email = this.userInfo.user_email
    var sp = email.split('@')
    if (sp[1] === 'acsicorp.com') {
      this.showRole = true
    }
    localStorage.getItem('viewid', JSON.stringify(this.viewid))
  },
  mixins: [validationMixin],
  validations: {
    // form: {
    //   comments: {
    //     required,
    //     maxLength: minLength(50)
    //   }
    // }
  },
  mounted () {
    // this.$root.$on('message_from_abc', (arg) => {
    //   console.log(arg)
    //   this.selectpost = this.datas[0]._id
    //   this.selectdata = this.datas[0]
    //   console.log('check')
    //   this.config = {
    //     headers: {
    //       'content-type': 'application/json',
    //       Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
    //     }
    //   }
    //   this.getReleventProfile(this.selectpost, this.selectdata)
    //   // this.uninterestRequest(arg)
    // })
  },
  methods: {
    updateinterestcount (type, intid) {
      const id = this.userInfo._id
      axios.get(BaseURL + '/dashboard/update_notification/web/' + id + '/' + this.selectpost + '/' + type, this.config).then(response => {
        this.reloaddata()
      }).catch(e => {
      })
    },
    reloaddata () {
      if (this.postsearch) {
        this.mainurl = '/dashboard/get_tobeschedulelist_web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
      } else {
        this.mainurl = '/dashboard/get_tobeschedulelist_web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
      }
      axios.get(`${this.base_urls}${this.mainurl}`, this.config).then(response => {
        this.datas = response.data.interviewerList
      }).catch(e => {
        console.log(e)
      })
    },
    showSheduledetails (id, status) {
      console.log(status)
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.sheduledetailsOpen = true
    },
    showModal (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.modalOpen = true
    },
    showShedule (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.shwovalue = true
    },
    submitRequest (_id) {
      this.tempId = _id
    },
    askTime (_id) {
      if (this.comments === '' || this.comments === undefined) {
        this.remarkAlert = 'Remarks is required*'
        this.submitted = false
      } else {
        this._id = this.userInfo._id
        const formData = {
          user_id: this.tempId,
          org_id: this._id,
          comments: this.comments
        }
        axios.post(this.base_urls + '/dashboard/add_seektime', { formData: formData }, this.config).then(response => {
          this.seektimemsg = response.data.message
          console.log(this.seektimemsg)
          if (this.seektimemsg === 'Success') {
          // this.showSeek = true
          // this.submitted = true
            $('#seekTime').modal('hide')
            this.getReleventProfile(this.selectpost, 'no')
          }
        }).catch(e => {
        // router.push({ name: 'Login' })
        })
      }
    },
    showReason (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.reasonopen = true
    },
    getReleventProfile (id, val) {
      this.selectpost = id
      this.getpostdata()
      let mainurl = '/dashboard/get_post_tobeschedulelist_web/' + id
      if (this.showRole) {
        mainurl = '/dashboard/get_post_tobeschedulelist_web_acs/' + id
      } else {
        mainurl = '/dashboard/get_post_tobeschedulelist_web/' + id
      }
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.releventprofiles = response.data.interviewerList
        this.releventprofilesLength = this.releventprofiles.length
        this.updateinterestcount('tobeschedule', this.viewid)
      }).catch(e => {
        console.log(e)
      })
    },
    getDatas () {
      if (this.postsearch) {
        this.mainurl = '/dashboard/get_tobeschedulelist_web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
      } else {
        this.mainurl = '/dashboard/get_tobeschedulelist_web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
      }
      axios.get(`${this.base_urls}${this.mainurl}`, this.config).then(response => {
        this.datas = response.data.interviewerList
        // console.log(this.datas)
        this.isLoading = false
        // if (this.selectdata !== 'no' && this.selectdata !== undefined && this.selectdata !== '' && this.selectdata !== null) {
        //   this.selectpost = this.selectdata.post_id
        //   console.log(this.selectpost)
        //   this.getReleventProfile(this.selectpost, 'no')
        // } else {
        //   if (this.datas.length > 0) {
        //     this.selectpost = this.datas[0]._id
        //     this.selectdata = this.datas[0]
        //     console.log('check')
        //     this.getReleventProfile(this.selectpost, this.selectdata)
        //   }
        // }
        if (this.datas.length > 0) {
          this.selectpost = this.datas[0]._id
          this.selectdata = this.datas[0]
          this.getReleventProfile(this.selectpost, this.selectdata)
        }
        // console.log(this.datas.some(data => data.id === this.selectpost))
        // if (!this.datas.some(data => data._id === this.selectpost)) {
        //   if (this.datas.length > 0) {
        //     this.selectpost = this.datas[0]._id
        //     this.selectdata = this.datas[0]
        //     console.log('check')
        //     this.getReleventProfile(this.selectpost, this.selectdata)
        //   }
        // }
        this.getpostdata()
      }).catch(e => {
        console.log(e)
      })
    },
    getpostdata () {
      const mainurl = '/dashboard/get_post_details/ios/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.selectdata = response.data.interviewerList[0]
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    }
  }

}
</script>

<style scoped>
.f11 {
  font-size: 11px;
}
.tabs.is-centered.is-fullwidth {
  margin-bottom: 0px;
}
ul {
    margin-bottom: 0;
    padding-bottom: 0;
}
.box___border {
  border-style: solid;
  border-width: 0px 0px 0px 0px;
  border-bottom-color: #98a2ac;
  border-right-color: #98a2ac;
  border-left-color: #98a2ac;
}
.navigation-tabs.full-pills .tabs ul {
  padding-bottom: 0px;
  border-bottom: 0px solid #fff !important;
}

.is-active {
    background-color: #fff;
}

.tabs ul li {
    text-align: center;
    padding: 9px;
    background-color: #f9f9f9;
    cursor: pointer;
}
li.green-tab.is-active {
  border-style: solid;
  border-width: 4px 0px 0px 0px;
  border-top-color: rgb(91, 173, 43);
  border-right-color: #98a2ac;
  border-left-color: #98a2ac;
}
.posttab li.green-tab.is-active {
  border-style: solid;
  border-width: 4px 0px 0px 0px;
  border-top-color: rgb(91, 173, 43);
  background: #5bad2b;
  color: #fff;
}
.flex-card .card-body.is-small {
  /* padding-right: 15px !important;
  padding-bottom: 15px !important;
  padding-left: 15px !important; */
  padding: 10px 0px;
}

.ul-padding {
  padding-top: 0px !important;
}

ol,
ul,
dl {
  margin-bottom: 0px;
}
li {
  border-bottom: 1px solid #ededed;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #fff;
}
.user-list li:hover {
  cursor: pointer;
  background-color: #f9f9f9;
  cursor: pointer;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #5BAD2B;
}
.user-list li.is-active {
  cursor: pointer;
  background-color: #f9f9f9;
  cursor: pointer;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #5BAD2B;
}
.pading-top-only {
  padding: 0px 18px 15px;
}
.flex-card.light-bordered.raised {
    box-shadow: none;
}
.flex-card.is-active .name {
    color: #23282c !important;
}
.view-all-btn {
  border: 1px solid #5BAD2B;
  padding: 9px;
}
.card-body li {
  border-bottom: 1px solid #ededed;
}
.view-all-btn {
    border: 1px solid #bfc1c7e8;
    padding: 5px;
}

.posttab ul li {
  padding: 4px;
}
.unintrest {
    border-color: #c8ced3;
    background-color: #ededed73 !important;
    color: #23282c !important;
}
.unintrest :hover {
  border-color: #5BAD2B;
  background-color: #5BAD2B;
  color: #fff;
}
input[type=radio]:checked + label {
  color: #f00;
  font-style: normal;
}

.posttab .tabs ul li[data-v-6e981812] {
    text-align: center;
    padding: 9px;
    background-color: #f9f9f9;
    cursor: pointer;
    border: 1px solid #ccc !important;
}
option:hover{

    background-color:white;
    color: black;

}
.img-avatar {
  width: 100%;
  height: 100%;
}
.profilename:hover {
  color:#5BAD2B;
}
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      max-height: calc(100vh - 40px);
      width: 501px;
  }
}

.selectdate {
  border: 1px solid #ccc;
}
.selectdate .txt {
  font-size: 12px;
  color: #73818f !important;
}
.post_interview-type {
  /* background-color: #5BAD2B !important;
  color: #fff !important;
  border: 1px solid #5BAD2B !important; */
  background-color: #fff !important;
  color: #656565 !important;
  border: 1px solid #c8ced3 !important;
}
.interview-type {
  height: 38px;
  text-align: center;
  padding: 0px !important;
  font-weight: 200;
  font-size: 12px;
  width: 47% !important;
  margin: 0px 15px;
  cursor: pointer;
}

.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now label,
.donate-now input {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.donate-now input[type="radio"] {
  opacity: 0.01;
  z-index: 100;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #5bad2b;
  color:#fff;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #CCC;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #DDD;
}
.card-body li {
    border-bottom: 0px;
}
.user-list li {
  border-bottom: 1px solid #ccc;
}
.remove-pad {
  padding-right: 0px;
  padding-left: 0px;
  border-right: 1px solid #d8d7d794;
  height: auto;
  min-height: 700px;
}
.nav-tabs-custom>.tab-content {
  padding: 0px;
  margin-top: 10px;
}
a {
    color: #333;
}
.tab-content {
  background-color: white;
  height: 100% !important;
  min-height: 700px;
  display: flow-root;
}
.box-header.with-border {
    border: 1px solid #d8d7d794;
}
.filterdrop {
  height: 29px;
  font-size: 12px !important;
}
.direct-chat-msg {
    margin-bottom: 0px;
}
.btns {
  background-color: white;
  color: #5bad2b;
}
.post li a {
  line-height: 15% !important;
}
.post.nav-tabs li {
  width: auto;
}
.post li {
  border-width: 0 0 0 0px !important;
}
.nav-tabs.post>li>a:hover {
    border-color: #f5f5f5 #f5f5f5 #f5f5f5 !important;
}
.posttab ul {
  background-color: #f5f5f5 !important;
}
.post li.active a{
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.ml8 {
  margin-left: 8px !important;
}
.direct-chat-messages {
  height: auto !important;
  border-bottom: 1px solid #cccccc73;
}
.direct-chat-messages:hover {
  border-left: 3px solid #5bad2b;
  background-color: #cccccc24;
}
.product-info {
  margin-top: 5px;
}
.btn-group {
  margin-right: 5px;
}
select.input-sm {
    height: 30px;
    line-height: 17px !important;
    border: 1px solid #88888840;
}
.products-list .product-info {
    margin-left: 58px !important;
}
.box {
  box-shadow: 0 1px 1px rgb(255, 255, 255) !important;
}
.txtarea{
   display: flex;
   flex-direction: column;
   justify-content: center;
 }
 .closebtnmodel{
   display: flex;
   flex-direction: row;
    justify-content: space-between;
    padding: 10px;
 }
 .seekbtn{
   margin-left: 4px;
 }
 .saveaccdetialsbtn{
  background-color: #5bad2b;
  color: white;
}
 /* .seekTime{
   display: flex;
   flex-direction: row;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    column-gap:3px ;
 } */
 .myseektime{
   width: 100%;
   display: flex;
    flex-direction: row;
    flex-wrap: wrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      column-gap:3px ;
 }
</style>
